import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

function UnauthorizedContent() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-900 to-[#F26522]/20 p-4">
      <div className="bg-gray-900 rounded-2xl shadow-2xl p-12 text-center max-w-md w-full relative overflow-hidden">
        <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-[#F26522]/20 pointer-events-none" />
        <div className="absolute -bottom-8 -left-8 w-36 h-36 rounded-full bg-[#F26522]/15 pointer-events-none" />
        <div className="relative">
          <img
            src="/LogoLiberty.png"
            alt="Liberty Latin America"
            className="h-16 mx-auto mb-6 brightness-0 invert"
          />
          <ShieldAlert className="w-12 h-12 text-[#F26522] mx-auto mb-4" />
          <h2 className="text-xl font-bold text-white mb-2">Access Denied</h2>
          <p className="text-gray-400 mb-6">You don't have permission to access this page.</p>
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 text-base font-medium rounded-lg text-white bg-gray-600 hover:bg-[#F26522] transition-colors duration-200"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default UnauthorizedContent;
